// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.loader[data-v-5f29ebe8] {\n    overflow: hidden;\n\n    /* width: 100px;\n  height: 100px; */\n    position: relative;\n}\n.loader[data-v-5f29ebe8]::before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n}\n\n/* Shape stylings */\n.shape--text[data-v-5f29ebe8] {\n    height: 20px;\n}\n.shape--round[data-v-5f29ebe8] {\n    border-radius: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
